

import { useRef } from 'react';
import { Upload, X, Image as ImageIcon } from 'lucide-react';

const CardForm = ({ data, onChange }) => {

  const logoRef = useRef(null);
  const image1Ref = useRef(null);
  const image2Ref = useRef(null);
  const image3Ref = useRef(null);
  const image4Ref = useRef(null);
  const image5Ref = useRef(null);
  const image6Ref = useRef(null);
  const image7Ref = useRef(null);
  const image8Ref = useRef(null);
  const image9Ref = useRef(null);
  const image10Ref = useRef(null);

  const pptRef = useRef(null);
  const pdfRef = useRef(null);



  const handleFileUpload = (field, file) => {
    onChange(field, file);
  };


  const renderInput = (key, label, type = 'text') => (
    <div>
      <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, }}>{label}</label>
      <input type={type} value={data[key]} onChange={(e) => onChange(key, e.target.value)} style={{ width: '100%', padding: '12px 14px', borderRadius: 14, border: '2px solid #e5e7eb', outline: 'none', fontSize: 14, }} />
    </div>
  );

  const renderDocumentUpload = (key, label, ref, accept) => (
    <div>
      <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>{label}</label>
      {data[key] ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 14, border: '2px solid #e5e7eb', }}>
          <span style={{ fontSize: 14 }}>{label} uploaded</span>
          <button onClick={() => onChange(key, '')} style={{ marginLeft: 'auto', background: '#ef4444', border: 'none', borderRadius: '50%', width: 24, height: 24, color: '#fff', }}>
            <X size={14} />
          </button>
        </div>
      ) : (
        <button onClick={() => ref.current.click()} style={{ width: '100%', padding: 14, borderRadius: 14, border: '2px dashed #e5e7eb', background: '#f9fafb', display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center', }}>
          <Upload size={16} /> Upload {label}
        </button>
      )}
      <input ref={ref} type="file" hidden accept={accept} onChange={(e) => handleFileUpload(key, e.target.files[0])} />
    </div>
  );


  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16, }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>Basic Information</h3>
        <div>
          <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, }}>Company Logo</label>
          <div style={{ display: 'flex', gap: 16 }}>
            {data.image ? (
              <div style={{ position: 'relative' }}>
                <img src={typeof data.image === 'string' ? data.image : URL.createObjectURL(data.image)} style={{ width: 80, height: 80, borderRadius: 14 }} />
                <button onClick={() => onChange('image', '')} style={{ position: 'absolute', top: -6, right: -6, width: 24, height: 24, borderRadius: '50%', background: '#ef4444', color: '#fff', border: 'none', }}>
                  <X size={14} />
                </button>
              </div>
            ) : (
              <button onClick={() => logoRef.current.click()} style={{ width: 80, height: 80, borderRadius: 14, border: '2px dashed #e5e7eb', background: '#f9fafb', }}><Upload /></button>
            )}
            <input ref={logoRef} type="file" hidden accept="image/*" onChange={(e) => handleFileUpload('image', e.target.files[0])} />
          </div>
        </div>
        {renderInput('companyName', 'Company Name *')}
        {renderInput('name', 'Your Name *')}
        {renderInput('designation', 'Designation *')}
      </section>
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16, }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>Contact Information</h3>
        {renderInput('phoneNumber', 'Phone Number *')}
        {renderInput('email', 'Email Address *', 'email')}
        {renderInput('al_email', 'Alternative Email Address', 'email')}
        <div>
          <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, }}>Address</label>
          <textarea value={data.address} onChange={(e) => onChange('address', e.target.value)} rows={3} style={{ ...{ width: '100%', padding: '12px 14px', borderRadius: 14, border: '2px solid #e5e7eb', outline: 'none', fontSize: 14, }, resize: 'none' }} />
        </div>
      </section>

      {/* ACTION LINKS */}
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16, }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>
          Action Links
        </h3>
        {renderInput('whatsappChat', 'WhatsApp Number')}
        {renderInput('call', 'Mobile Number')}
        {renderInput('location', 'Google Maps Link')}
        {renderInput('website', 'Website URL')}
      </section>
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16, }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>
          Media
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: 16 }}>
          {[['image1', image1Ref], ['image2', image2Ref], ['image3', image3Ref], ['image4', image4Ref], ['image5', image5Ref]
            , ['image6', image6Ref], ['image7', image7Ref], ['image8', image8Ref], ['image9', image9Ref], ['image10', image10Ref]].map(([key, ref]) => (
              <div key={key}>
                <label style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, }}>{key.toUpperCase()}</label>
                {data[key] ? (
                  <div style={{ position: 'relative' }}>
                    <img src={typeof data[key] === 'string' ? data[key] : URL.createObjectURL(data[key])} alt={key} style={{ width: '100%', borderRadius: 14 }} />
                    <button onClick={() => onChange(key, '')} style={{ position: 'absolute', top: 8, right: 8, background: '#ef4444', borderRadius: '50%', width: 24, height: 24, border: 'none', color: '#fff', }}>
                      <X size={14} />
                    </button>
                  </div>
                ) : (
                  <button onClick={() => ref.current.click()} style={{ width: '100%', height: 120, borderRadius: 14, border: '2px dashed #e5e7eb', background: '#f9fafb', }}><ImageIcon /></button>
                )}
                <input ref={ref} type="file" hidden accept="image/*" onChange={(e) => handleFileUpload(key, e.target.files[0])} />
              </div>
            ))}
        </div>
        {renderInput('videoUrl1', 'Video 1 URL')}
        {renderInput('videoUrl2', 'Video 2 URL')}
      </section>

      {/* Documents */}
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>Documents</h3>
        {renderDocumentUpload('ppt', 'PPT', pptRef, '.ppt,.pptx')}
        {renderDocumentUpload('pdf', 'PDF', pdfRef, '.pdf')}
      </section>


      {/* SOCIAL */}
      <section style={{ display: 'flex', flexDirection: 'column', gap: 16, }}>
        <h3 style={{ fontSize: 20, fontWeight: 'bold', borderBottom: '1px solid #e5e7eb', paddingBottom: 8 }}>Social Media</h3>
        {renderInput('facebookUrl', 'Facebook')}
        {renderInput('linkedinUrl', 'LinkedIn')}
        {renderInput('instagramUrl', 'Instagram')}
        {renderInput('twitterUrl', 'Twitter (X)')}
        {renderInput('telegramUrl', 'Telegram')}
      </section>
    </div>
  );
};

export default CardForm;

